// Shipping Protection Handler
(function() {
  'use strict';
  
  const SHIPPING_PROTECTION_VARIANT_ID = '49226712416493';
  
  // Track if user has explicitly unchecked
  let userExplicitlyUnchecked = false;
  
  document.addEventListener('DOMContentLoaded', function() {
    const checkbox = document.getElementById('shipping-protection');
    
    if (checkbox) {
      // Check if we should auto-check the checkbox
      autoCheckShippingProtection(checkbox);
      
      // Add event listener
      checkbox.addEventListener('change', handleShippingProtectionChange);
    }
    
    fixCheckoutButton();
  });
  
  function autoCheckShippingProtection(checkbox) {
    // Check if user has previously unchecked
    if (sessionStorage.getItem('shippingProtectionUnchecked') === 'true') {
      userExplicitlyUnchecked = true;
      return; // Don't auto-check if user has explicitly unchecked
    }
    
    // Check if cart has regular items (not shipping protection)
    const cartItems = document.querySelectorAll('.cart-item');
    let hasRegularItems = false;
    
    cartItems.forEach(item => {
      const itemName = item.querySelector('.cart-item__name');
      const itemPrice = item.querySelector('.cart-item__price .price');
      
      if (itemName && itemPrice) {
        const nameText = itemName.textContent.toLowerCase();
        const priceText = itemPrice.textContent.trim();
        
        // Check if this is NOT shipping protection
        if (!nameText.includes('shipping protection') && 
            !nameText.includes('shipping-protection') &&
            priceText !== '$1.99' && priceText !== '$1.99 USD') {
          hasRegularItems = true;
        }
      }
    });
    
    // If we have regular items and checkbox is not checked, and user hasn't explicitly unchecked
    if (hasRegularItems && !checkbox.checked && !userExplicitlyUnchecked) {
      checkbox.checked = true;
      checkbox.setAttribute('checked', 'checked');
      
      // Auto-add shipping protection but don't reload immediately
      // Let the user see the checkbox is checked, they can uncheck if they want
      setTimeout(() => {
        if (checkbox.checked) {
          addShippingProtection();
        }
      }, 1000);
    }
  }
  
  async function addShippingProtection() {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: SHIPPING_PROTECTION_VARIANT_ID,
            quantity: 1
          }]
        })
      });
      
      // Update the page without full reload
      updateCartDisplay();
      
    } catch (error) {
      console.error('Error adding shipping protection:', error);
    }
  }
  
  async function removeShippingProtection() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      // Find shipping protection item
      let lineToRemove = null;
      for (let i = 0; i < cartData.items.length; i++) {
        const item = cartData.items[i];
        if (item.variant_id == SHIPPING_PROTECTION_VARIANT_ID) {
          lineToRemove = i + 1;
          break;
        }
      }
      
      if (lineToRemove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: lineToRemove,
            quantity: 0
          })
        });
        
        // Update the page without full reload
        updateCartDisplay();
      }
      
    } catch (error) {
      console.error('Error removing shipping protection:', error);
    }
  }
  
  async function handleShippingProtectionChange(e) {
    const checkbox = e.target;
    const shouldAdd = checkbox.checked;
    
    // Disable during processing
    checkbox.disabled = true;
    const wrapper = checkbox.closest('.shipping-protection-wrapper');
    if (wrapper) wrapper.classList.add('loading');
    
    try {
      if (shouldAdd) {
        // Add shipping protection
        await addShippingProtection();
        // Remove the unchecked flag
        sessionStorage.removeItem('shippingProtectionUnchecked');
        userExplicitlyUnchecked = false;
      } else {
        // Remove shipping protection
        await removeShippingProtection();
        // Set flag that user explicitly unchecked
        sessionStorage.setItem('shippingProtectionUnchecked', 'true');
        userExplicitlyUnchecked = true;
      }
      
    } catch (error) {
      console.error('Shipping protection error:', error);
      checkbox.checked = !shouldAdd;
      checkbox.disabled = false;
      if (wrapper) wrapper.classList.remove('loading');
      alert('Unable to update shipping protection. Please refresh and try again.');
    }
  }
  
  async function updateCartDisplay() {
    try {
      // Get updated cart
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      // Update the checkbox text with current price
      const checkbox = document.getElementById('shipping-protection');
      if (checkbox) {
        const priceSpan = checkbox.parentNode.querySelector('span');
        if (priceSpan) {
          // Find shipping protection price in cart
          let shippingPrice = 199; // default
          for (const item of cartData.items) {
            if (item.variant_id == SHIPPING_PROTECTION_VARIANT_ID) {
              shippingPrice = item.price;
              break;
            }
          }
          
          // Format price
          const formattedPrice = (shippingPrice / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          });
          
          priceSpan.textContent = `Add Shipping Protection - ${formattedPrice}`;
        }
        
        // Re-enable checkbox
        checkbox.disabled = false;
        const wrapper = checkbox.closest('.shipping-protection-wrapper');
        if (wrapper) wrapper.classList.remove('loading');
      }
      
      // Update subtotal
      const subtotalElement = document.querySelector('.totals__subtotal-value');
      if (subtotalElement) {
        const formattedTotal = (cartData.total_price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        subtotalElement.textContent = formattedTotal;
      }
      
      // Show success message
      showMessage('Cart updated successfully!', 'success');
      
    } catch (error) {
      console.error('Error updating cart display:', error);
      
      // Re-enable checkbox on error
      const checkbox = document.getElementById('shipping-protection');
      if (checkbox) {
        checkbox.disabled = false;
        const wrapper = checkbox.closest('.shipping-protection-wrapper');
        if (wrapper) wrapper.classList.remove('loading');
      }
      
      showMessage('Error updating cart. Please refresh the page.', 'error');
    }
  }
  
  function showMessage(message, type) {
    // Remove any existing messages
    const existingMessage = document.getElementById('shipping-protection-message');
    if (existingMessage) existingMessage.remove();
    
    // Create message element
    const messageDiv = document.createElement('div');
    messageDiv.id = 'shipping-protection-message';
    messageDiv.style.cssText = `
      padding: 10px;
      margin: 10px 0;
      border-radius: 4px;
      font-size: 14px;
      text-align: center;
    `;
    
    if (type === 'success') {
      messageDiv.style.backgroundColor = '#d4edda';
      messageDiv.style.color = '#155724';
      messageDiv.style.border = '1px solid #c3e6cb';
    } else {
      messageDiv.style.backgroundColor = '#f8d7da';
      messageDiv.style.color = '#721c24';
      messageDiv.style.border = '1px solid #f5c6cb';
    }
    
    messageDiv.textContent = message;
    
    // Insert after the shipping protection wrapper
    const wrapper = document.querySelector('.shipping-protection-wrapper');
    if (wrapper) {
      wrapper.parentNode.insertBefore(messageDiv, wrapper.nextSibling);
      
      // Remove message after 3 seconds
      setTimeout(() => {
        if (messageDiv.parentNode) {
          messageDiv.remove();
        }
      }, 3000);
    }
  }
  
  function fixCheckoutButton() {
    const buttons = document.querySelectorAll('button[name="checkout"]');
    buttons.forEach(button => {
      button.classList.remove('loading', 'btn--loading', 'is-loading');
      button.disabled = false;
    });
  }
})();